import { getStructuredQuestionsUrl } from "../config/Config";
import { getRequest, putRequest } from "./ServiceHelper";

export class StructuredQuestionService {
  /**
   * Retrieves structured questions.
   * @param {string} contextId- The ID of a context
   * @returns {Promise<Object>} The structured questions
   */
  static getStructuredQuestions = (contextId) => {
    return getRequest(getStructuredQuestionsUrl(contextId));
  };

  /**
   * Creates or updates structured questions (bulk upsert).
   * @param {string} contextId - The ID of a context
   * @param {Array} questions - Array of question objects to upsert
   * @returns {Promise<Object>} The upserted questions
   */
  static upsertStructuredQuestions = (contextId, questions) => {
    const body = {
      questions: questions.map((q, idx) => ({
        id: q.id || undefined,
        questionText: q.question_text,
        helperText: q.helper_text || "",
        fileUploadEnabled: q.file_upload_enabled || false,
        sequence: q.sequence || idx,
      })),
    };
    return putRequest(getStructuredQuestionsUrl(contextId), body);
  };
}
